module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-800-latin-ext17.d035c4a.woff2";